import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import { getSingleOnboarding } from "../../../../redux/learner/actions";
import {
  selectOnboardingsLoaded,
  selectOnboardingsLoading,
  selectSingleOnboarding,
} from "../../../../redux/learner/selector";

const mapStateToProps = (state: StateType) => ({
  onboarding: selectSingleOnboarding(state),
  loading: selectOnboardingsLoading(state),
  loaded: selectOnboardingsLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getSingleOnboarding,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
